import React, { useState, useEffect } from 'react';
import { 
  Box, 
  Typography, 
  TextField, 
  Grid, 
  MenuItem, 
  Button, 
  InputAdornment, 
  Autocomplete,
  Paper,
  Chip,
  FormControl,
  InputLabel,
  Select,
  Slider,
  Card,
  CardMedia,
  CardContent,
  Switch,
  FormControlLabel,
  Alert,
  CircularProgress
} from '@mui/material';
import { useTheme, alpha } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { getFirestore, collection, getDocs, doc, getDoc } from 'firebase/firestore';
import { isDressLinkedToAccount } from '../../utils/dressOwnerUtils';
import MapSection from '../../components/MapSection';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import PlaceIcon from '@mui/icons-material/Place';
import StarIcon from '@mui/icons-material/Star';

const tailles = ['32', '34', '36', '38', '40', '42', '44', '46', '48'];

// Données de localisation pour la France
const villesFrance = [
  { nom: 'Paris', codePostal: '75001', arrondissement: '1er arrondissement' },
  { nom: 'Paris', codePostal: '75002', arrondissement: '2ème arrondissement' },
  { nom: 'Paris', codePostal: '75003', arrondissement: '3ème arrondissement' },
  { nom: 'Paris', codePostal: '75004', arrondissement: '4ème arrondissement' },
  { nom: 'Paris', codePostal: '75005', arrondissement: '5ème arrondissement' },
  { nom: 'Paris', codePostal: '75006', arrondissement: '6ème arrondissement' },
  { nom: 'Paris', codePostal: '75007', arrondissement: '7ème arrondissement' },
  { nom: 'Paris', codePostal: '75008', arrondissement: '8ème arrondissement' },
  { nom: 'Paris', codePostal: '75009', arrondissement: '9ème arrondissement' },
  { nom: 'Paris', codePostal: '75010', arrondissement: '10ème arrondissement' },
  { nom: 'Paris', codePostal: '75011', arrondissement: '11ème arrondissement' },
  { nom: 'Paris', codePostal: '75012', arrondissement: '12ème arrondissement' },
  { nom: 'Paris', codePostal: '75013', arrondissement: '13ème arrondissement' },
  { nom: 'Paris', codePostal: '75014', arrondissement: '14ème arrondissement' },
  { nom: 'Paris', codePostal: '75015', arrondissement: '15ème arrondissement' },
  { nom: 'Paris', codePostal: '75016', arrondissement: '16ème arrondissement' },
  { nom: 'Paris', codePostal: '75017', arrondissement: '17ème arrondissement' },
  { nom: 'Paris', codePostal: '75018', arrondissement: '18ème arrondissement' },
  { nom: 'Paris', codePostal: '75019', arrondissement: '19ème arrondissement' },
  { nom: 'Paris', codePostal: '75020', arrondissement: '20ème arrondissement' },
  { nom: 'Lyon', codePostal: '69001', arrondissement: '1er arrondissement' },
  { nom: 'Lyon', codePostal: '69002', arrondissement: '2ème arrondissement' },
  { nom: 'Lyon', codePostal: '69003', arrondissement: '3ème arrondissement' },
  { nom: 'Lyon', codePostal: '69004', arrondissement: '4ème arrondissement' },
  { nom: 'Lyon', codePostal: '69005', arrondissement: '5ème arrondissement' },
  { nom: 'Lyon', codePostal: '69006', arrondissement: '6ème arrondissement' },
  { nom: 'Lyon', codePostal: '69007', arrondissement: '7ème arrondissement' },
  { nom: 'Lyon', codePostal: '69008', arrondissement: '8ème arrondissement' },
  { nom: 'Lyon', codePostal: '69009', arrondissement: '9ème arrondissement' },
  { nom: 'Marseille', codePostal: '13001', arrondissement: '1er arrondissement' },
  { nom: 'Marseille', codePostal: '13002', arrondissement: '2ème arrondissement' },
  { nom: 'Marseille', codePostal: '13003', arrondissement: '3ème arrondissement' },
  { nom: 'Marseille', codePostal: '13004', arrondissement: '4ème arrondissement' },
  { nom: 'Marseille', codePostal: '13005', arrondissement: '5ème arrondissement' },
  { nom: 'Marseille', codePostal: '13006', arrondissement: '6ème arrondissement' },
  { nom: 'Marseille', codePostal: '13007', arrondissement: '7ème arrondissement' },
  { nom: 'Marseille', codePostal: '13008', arrondissement: '8ème arrondissement' },
  { nom: 'Marseille', codePostal: '13009', arrondissement: '9ème arrondissement' },
  { nom: 'Marseille', codePostal: '13010', arrondissement: '10ème arrondissement' },
  { nom: 'Marseille', codePostal: '13011', arrondissement: '11ème arrondissement' },
  { nom: 'Marseille', codePostal: '13012', arrondissement: '12ème arrondissement' },
  { nom: 'Marseille', codePostal: '13013', arrondissement: '13ème arrondissement' },
  { nom: 'Marseille', codePostal: '13014', arrondissement: '14ème arrondissement' },
  { nom: 'Marseille', codePostal: '13015', arrondissement: '15ème arrondissement' },
  { nom: 'Marseille', codePostal: '13016', arrondissement: '16ème arrondissement' },
  { nom: 'Toulouse', codePostal: '31000', arrondissement: 'Centre' },
  { nom: 'Nice', codePostal: '06000', arrondissement: 'Centre' },
  { nom: 'Nantes', codePostal: '44000', arrondissement: 'Centre' },
  { nom: 'Montpellier', codePostal: '34000', arrondissement: 'Centre' },
  { nom: 'Strasbourg', codePostal: '67000', arrondissement: 'Centre' },
  { nom: 'Bordeaux', codePostal: '33000', arrondissement: 'Centre' },
  { nom: 'Lille', codePostal: '59000', arrondissement: 'Centre' },
  { nom: 'Rennes', codePostal: '35000', arrondissement: 'Centre' },
  { nom: 'Reims', codePostal: '51100', arrondissement: 'Centre' },
  { nom: 'Le Havre', codePostal: '76600', arrondissement: 'Centre' },
  { nom: 'Saint-Étienne', codePostal: '42000', arrondissement: 'Centre' },
  { nom: 'Toulon', codePostal: '83000', arrondissement: 'Centre' },
  { nom: 'Angers', codePostal: '49000', arrondissement: 'Centre' },
  { nom: 'Grenoble', codePostal: '38000', arrondissement: 'Centre' },
  { nom: 'Dijon', codePostal: '21000', arrondissement: 'Centre' },
  { nom: 'Nîmes', codePostal: '30000', arrondissement: 'Centre' },
  { nom: 'Aix-en-Provence', codePostal: '13100', arrondissement: 'Centre' }
];

// Suggestions de recherche populaires
const searchSuggestions = [
  'Robe de bal',
  'Robe de cocktail',
  'Robe mini',
  'Robe de mariée',
  'Robe de soirée',
  'Robe longue',
  'Robe courte',
  'Robe rouge',
  'Robe noire',
  'Robe blanche',
  'Robe bleue',
  'Robe rose',
  'Robe verte',
  'Robe dorée',
  'Robe argentée',
  'Robe à paillettes',
  'Robe vintage',
  'Robe moderne',
  'Robe classique',
  'Robe bohème',
  'Robe romantique',
  'Robe sexy',
  'Robe décontractée',
  'Robe de travail',
  'Robe de plage',
  'Robe d\'été',
  'Robe d\'hiver',
  'Robe de printemps',
  'Robe de gala',
  'Robe de réception'
];

// Suggestions personnalisées
const personalizedSuggestions = [
  'Robes tendance pour un mariage',
  'Dernières ajoutées près de vous',
  'Robes de cocktail pour soirée',
  'Robes vintage à la mode',
  'Robes de luxe pour gala',
  'Robes bohème pour festival',
  'Robes de travail élégantes',
  'Robes de plage estivales',
  'Robes de bal princesse',
  'Robes romantiques pour rendez-vous'
];

// Options de filtres
const categories = [
  'Robe longue',
  'Robe courte',
  'Robe de cocktail',
  'Robe de bal',
  'Robe de mariée',
  'Robe de soirée',
  'Robe de travail',
  'Robe décontractée',
  'Robe de plage',
  'Robe vintage'
];
const marques = [
  'Chanel',
  'Dior',
  'Versace',
  'Valentino',
  'Elie Saab',
  'Zimmermann',
  'Self-Portrait',
  'Réalisation Par',
  'Rent the Runway',
  'Autre'
];
const couleurs = [
  'Noir',
  'Blanc',
  'Rouge',
  'Bleu',
  'Rose',
  'Vert',
  'Jaune',
  'Violet',
  'Doré',
  'Argenté',
  'Beige',
  'Marron'
];
const styles = [
  'Classique',
  'Moderne',
  'Vintage',
  'Bohème',
  'Romantique',
  'Sexy',
  'Élégant',
  'Décontracté',
  'Chic',
  'Sophistiqué'
];

// Fonction pour obtenir la valeur hexadécimale des couleurs
const getColorValue = (colorName: string): string => {
  const colorMap: { [key: string]: string } = {
    'Noir': '#000000',
    'Blanc': '#FFFFFF',
    'Rouge': '#FF0000',
    'Bleu': '#0000FF',
    'Rose': '#FFC0CB',
    'Vert': '#008000',
    'Jaune': '#FFFF00',
    'Violet': '#800080',
    'Doré': '#FFD700',
    'Argenté': '#C0C0C0',
    'Beige': '#F5F5DC',
    'Marron': '#8B4513'
  };
  return colorMap[colorName] || '#CCCCCC';
};

const RechercheTab: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const accentSoft = alpha(theme.palette.primary.main, 0.22);
  const accentGlow = alpha(theme.palette.primary.main, 0.28);
  const [search, setSearch] = useState('');
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  const [filters, setFilters] = useState({
    taille: '',
    categorie: '',
    marque: '',
    prixMin: 0,
    prixMax: 500,
    distance: 10,
    couleur: '',
    style: ''
  });
  const [dateDebut, setDateDebut] = useState<Date | null>(null);
  const [dateFin, setDateFin] = useState<Date | null>(null);
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [selectingPeriod, setSelectingPeriod] = useState(false);
  const [tempStartDate, setTempStartDate] = useState<Date | null>(null);
  
  // États pour la localisation
  const [locationFilters, setLocationFilters] = useState({
    ville: '',
    codePostal: '',
    useGeolocation: false,
    currentLocation: null as { lat: number; lng: number } | null,
    searchRadius: 10
  });
  const [isGeolocating, setIsGeolocating] = useState(false);
  const [geolocationError, setGeolocationError] = useState<string | null>(null);
  
  // États pour le tri et les statistiques
  const [sortBy, setSortBy] = useState<'proximite' | 'prix' | 'popularite' | 'nouveautes'>('proximite');
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('asc');
  const [showStats, setShowStats] = useState(true);
  
  // État pour les robes
  const [dresses, setDresses] = useState<any[]>([]);
  const [loadingDresses, setLoadingDresses] = useState(true);

  // Fonctions de géolocalisation
  const getCurrentLocation = () => {
    setIsGeolocating(true);
    setGeolocationError(null);

    if (!navigator.geolocation) {
      setGeolocationError('La géolocalisation n\'est pas supportée par votre navigateur');
      setIsGeolocating(false);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        setLocationFilters(prev => ({
          ...prev,
          currentLocation: { lat: latitude, lng: longitude },
          useGeolocation: true,
          ville: '',
          codePostal: ''
        }));
        setIsGeolocating(false);
      },
      (error) => {
        let errorMessage = 'Erreur de géolocalisation';
        switch (error.code) {
          case error.PERMISSION_DENIED:
            errorMessage = 'Permission de géolocalisation refusée';
            break;
          case error.POSITION_UNAVAILABLE:
            errorMessage = 'Position non disponible';
            break;
          case error.TIMEOUT:
            errorMessage = 'Délai d\'attente dépassé';
            break;
        }
        setGeolocationError(errorMessage);
        setIsGeolocating(false);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 300000 // 5 minutes
      }
    );
  };

  const handleLocationChange = (field: string, value: any) => {
    setLocationFilters(prev => ({
      ...prev,
      [field]: value,
      useGeolocation: field !== 'ville' && field !== 'codePostal' ? prev.useGeolocation : false
    }));
  };

  // Fonctions de tri
  const sortDresses = (dresses: any[]) => {
    return [...dresses].sort((a, b) => {
      let comparison = 0;
      
      switch (sortBy) {
        case 'proximite':
          // Simulation de la proximité basée sur la distance
          comparison = a.distance - b.distance;
          break;
        case 'prix':
          comparison = a.price - b.price;
          break;
        case 'popularite':
          // Tri par nombre de vues + favoris
          const aPopularity = a.views + (a.favorites * 2);
          const bPopularity = b.views + (b.favorites * 2);
          comparison = bPopularity - aPopularity;
          break;
        case 'nouveautes':
          // Tri par date d'ajout (plus récent en premier)
          comparison = new Date(b.dateAdded).getTime() - new Date(a.dateAdded).getTime();
          break;
      }
      
      return sortOrder === 'asc' ? comparison : -comparison;
    });
  };

  const handleSortChange = (newSortBy: typeof sortBy) => {
    if (sortBy === newSortBy) {
      setSortOrder(prev => prev === 'asc' ? 'desc' : 'asc');
    } else {
      setSortBy(newSortBy);
      setSortOrder(newSortBy === 'prix' ? 'asc' : 'desc');
    }
  };

  // Charger les robes depuis Firestore
  useEffect(() => {
    const loadDresses = async () => {
      try {
        setLoadingDresses(true);
        const db = getFirestore();
        const dressesCollection = collection(db, 'dresses');
        const dressesSnapshot = await getDocs(dressesCollection);
        
        const dressesData: any[] = [];
        const candidates: { id: string; data: Record<string, unknown> }[] = [];
        dressesSnapshot.forEach((d) => {
          candidates.push({ id: d.id, data: d.data() as Record<string, unknown> });
        });

        const rows = await Promise.all(
          candidates.map(async ({ id, data }) => {
            const link = await isDressLinkedToAccount(db, data);
            if (!link.valid) {
              console.log('🚫 Robe filtrée (non rattachée à un compte):', {
                id,
                title: data.title || data.name,
                reason: link.reason,
                ownerUid: link.ownerUid,
              });
              return null;
            }
            return {
              id,
              title: (data.title as string) || (data.name as string) || 'Robe sans titre',
              image: (data.images as string[])?.[0] || (data.image as string) || '',
              price: (data.price as number) || 0,
              size: (data.size as string) || '',
              location: (data.location as string) || 'Non spécifié',
              distance: (data.distance as number) || 0,
              views: (data.views as number) || 0,
              favorites: (data.favorites as number) || 0,
              dateAdded:
                (data.createdAt as { toDate?: () => Date })?.toDate?.()?.toISOString() ||
                (data.dateAdded as string) ||
                new Date().toISOString(),
              owner: (data.ownerName as string) || (data.owner as string) || 'Propriétaire',
              rating: (data.rating as number) || 0,
            };
          })
        );

        rows.forEach((row) => {
          if (row) dressesData.push(row);
        });
        
        setDresses(dressesData);
      } catch (error) {
        console.error('Erreur lors du chargement des robes:', error);
        setDresses([]);
      } finally {
        setLoadingDresses(false);
      }
    };

    loadDresses();
  }, []);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ color: 'primary.main', mb: 3 }}>
        Recherche
      </Typography>

      {/* Barre de recherche principale */}
      <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" gutterBottom sx={{ color: 'primary.main' }}>
          Barre de recherche (par taille, couleur, style, marque, prix, localisation)
        </Typography>
        
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={7}>
            <Autocomplete
              freeSolo
              options={[...searchSuggestions, ...personalizedSuggestions]}
              value={search}
              onInputChange={(event, newValue) => {
                setSearch(newValue || '');
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
              variant="outlined"
                  placeholder="Rechercher une robe..."
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              )}
              renderOption={(props, option) => (
                <Box component="li" {...props}>
                  <SearchIcon sx={{ mr: 1, fontSize: 20 }} />
                  {option}
                </Box>
              )}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <Button
              variant="contained"
              startIcon={<FilterListIcon />}
              fullWidth
              onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
              sx={{ 
                backgroundColor: 'primary.main', 
                '&:hover': { backgroundColor: 'primary.dark' },
                height: '56px'
              }}
            >
              Filtres avancés
            </Button>
          </Grid>
          <Grid item xs={12} md={2}>
            <Button
              variant="contained"
              startIcon={<SearchIcon />}
              fullWidth
              sx={{ 
                backgroundColor: 'primary.main', 
                '&:hover': { backgroundColor: 'primary.dark' },
                height: '56px'
              }}
            >
              Rechercher
            </Button>
          </Grid>
        </Grid>
      </Paper>

      {/* Suggestions personnalisées */}
      <Paper elevation={2} sx={{ p: 2, mb: 3 }}>
        <Typography variant="h6" gutterBottom sx={{ color: 'primary.main', display: 'flex', alignItems: 'center' }}>
          <TrendingUpIcon sx={{ mr: 1 }} />
          Suggestions personnalisées
            </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {personalizedSuggestions.map((suggestion, index) => (
            <Chip
              key={index}
              label={suggestion}
              onClick={() => setSearch(suggestion)}
              sx={{
                backgroundColor: '#f5f5f5',
                '&:hover': { backgroundColor: 'primary.main', color: 'white' },
                cursor: 'pointer'
              }}
            />
          ))}
        </Box>
      </Paper>

      {/* Filtres avancés */}
      {showAdvancedFilters && (
        <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
          <Typography variant="h6" gutterBottom sx={{ color: 'primary.main' }}>
            Filtres avancés
          </Typography>
          
          <Grid container spacing={3}>
            {/* Taille */}
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Taille</InputLabel>
                <Select
                  value={filters.taille}
                  onChange={(e) => setFilters({...filters, taille: e.target.value})}
                  label="Taille"
                >
                  <MenuItem value="">Toutes les tailles</MenuItem>
                  {tailles.map(taille => (
                    <MenuItem key={taille} value={taille}>{taille}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Catégorie */}
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Catégorie</InputLabel>
                <Select
                  value={filters.categorie}
                  onChange={(e) => setFilters({...filters, categorie: e.target.value})}
                  label="Catégorie"
                >
                  <MenuItem value="">Toutes les catégories</MenuItem>
                  {categories.map(categorie => (
                    <MenuItem key={categorie} value={categorie}>{categorie}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Marque */}
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Marque / Designer</InputLabel>
                <Select
                  value={filters.marque}
                  onChange={(e) => setFilters({...filters, marque: e.target.value})}
                  label="Marque / Designer"
                >
                  <MenuItem value="">Toutes les marques</MenuItem>
                  {marques.map(marque => (
                    <MenuItem key={marque} value={marque}>{marque}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Distance */}
            <Grid item xs={12} md={3}>
              <Box>
                <Typography gutterBottom sx={{ color: 'primary.main' }}>
                  Distance: {filters.distance} km
                </Typography>
                <Slider
                  value={filters.distance}
                  onChange={(e, newValue) => setFilters({...filters, distance: newValue as number})}
                  min={1}
                  max={50}
                  step={1}
                  valueLabelDisplay="auto"
                  sx={{ color: 'primary.main' }}
                />
              </Box>
            </Grid>
          </Grid>

          {/* Section Filtrage Géographique */}
          <Box sx={{ mt: 4, p: 3, backgroundColor: '#f8f9fa', borderRadius: 2, border: '1px solid #e0e0e0' }}>
            <Typography variant="h6" gutterBottom sx={{ color: 'primary.main', display: 'flex', alignItems: 'center' }}>
              <LocationOnIcon sx={{ mr: 1 }} />
              Filtrage Géographique
            </Typography>
            
            <Grid container spacing={3}>
              {/* Mode de recherche géographique */}
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={locationFilters.useGeolocation}
                      onChange={(e) => handleLocationChange('useGeolocation', e.target.checked)}
                      sx={{ 
                        '& .MuiSwitch-switchBase.Mui-checked': {
                          color: 'primary.main',
                        },
                        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                          backgroundColor: 'primary.main',
                        }
                      }}
                    />
                  }
                  label="Utiliser ma position actuelle"
                />
                {locationFilters.useGeolocation && (
                  <Typography variant="body2" color="text.secondary" sx={{ ml: 4, mt: 1 }}>
                    Recherche basée sur votre géolocalisation
                  </Typography>
                )}
              </Grid>

              {/* Géolocalisation */}
              {locationFilters.useGeolocation ? (
                <Grid item xs={12} md={6}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Button
                      variant="outlined"
                      startIcon={isGeolocating ? <CircularProgress size={20} /> : <MyLocationIcon />}
                      onClick={getCurrentLocation}
                      disabled={isGeolocating}
                      sx={{ 
                        borderColor: 'primary.main', 
                        color: 'primary.main',
                        '&:hover': { borderColor: 'primary.dark' }
                      }}
                    >
                      {isGeolocating ? 'Géolocalisation...' : 'Détecter ma position'}
                    </Button>
                    
                    {locationFilters.currentLocation && (
                      <Chip
                        icon={<PlaceIcon />}
                        label={`${locationFilters.currentLocation.lat.toFixed(4)}, ${locationFilters.currentLocation.lng.toFixed(4)}`}
                        color="primary"
                        variant="outlined"
                        sx={{ 
                          borderColor: 'primary.main', 
                          color: 'primary.main',
                          '& .MuiChip-icon': { color: 'primary.main' }
                        }}
                      />
                    )}
                  </Box>
                  
                  {geolocationError && (
                    <Alert severity="error" sx={{ mt: 2 }}>
                      {geolocationError}
                    </Alert>
                  )}
                </Grid>
              ) : (
                <>
                  {/* Ville */}
                  <Grid item xs={12} md={6}>
                    <Autocomplete
                      freeSolo
                      options={villesFrance.map(v => v.nom)}
                      value={locationFilters.ville}
                      onInputChange={(event, newValue) => {
                        handleLocationChange('ville', newValue || '');
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Ville"
                          placeholder="Rechercher une ville..."
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: (
                              <InputAdornment position="start">
                                <LocationOnIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                      renderOption={(props, option) => {
                        const villeData = villesFrance.find(v => v.nom === option);
                        return (
                          <Box component="li" {...props}>
                            <Box>
                              <Typography variant="body1">{option}</Typography>
                              {villeData && (
                                <Typography variant="caption" color="text.secondary">
                                  {villeData.arrondissement} - {villeData.codePostal}
                                </Typography>
                              )}
                            </Box>
                          </Box>
                        );
                      }}
                    />
                  </Grid>

                  {/* Code postal */}
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Code postal"
                      placeholder="Ex: 75001"
                      value={locationFilters.codePostal}
                      onChange={(e) => handleLocationChange('codePostal', e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <PlaceIcon />
                          </InputAdornment>
                        ),
                      }}
                      helperText="Optionnel - améliore la précision de la recherche"
                    />
                  </Grid>
                </>
              )}

              {/* Rayon de recherche */}
              <Grid item xs={12} md={6}>
                <Box>
                  <Typography gutterBottom sx={{ color: 'primary.main' }}>
                    Rayon de recherche: {locationFilters.searchRadius} km
                  </Typography>
                  <Slider
                    value={locationFilters.searchRadius}
                    onChange={(e, newValue) => handleLocationChange('searchRadius', newValue)}
                    min={1}
                    max={100}
                    step={5}
                    valueLabelDisplay="auto"
                    sx={{ color: 'primary.main' }}
                  />
                  <Typography variant="caption" color="text.secondary">
                    Recherche dans un rayon de {locationFilters.searchRadius} km
                  </Typography>
                </Box>
              </Grid>

              {/* Affichage du mode de recherche */}
              <Grid item xs={12}>
                <Box sx={{ p: 2, backgroundColor: 'white', borderRadius: 1, border: '1px solid #e0e0e0' }}>
                  <Typography variant="body2" sx={{ color: 'primary.main', fontWeight: 'bold' }}>
                    Mode de recherche actuel:
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {locationFilters.useGeolocation 
                      ? `📍 Géolocalisation (${locationFilters.currentLocation ? 'Position détectée' : 'En attente de géolocalisation'})`
                      : locationFilters.ville 
                        ? `🏙️ Ville: ${locationFilters.ville}${locationFilters.codePostal ? ` (${locationFilters.codePostal})` : ''}`
                        : '🌍 Recherche dans toute la France'
                    }
                    <br />
                    📏 Rayon: {locationFilters.searchRadius} km
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>

          {/* Budget */}
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Box>
                <Typography gutterBottom sx={{ color: 'primary.main' }}>
                  Budget: {filters.prixMin}€ - {filters.prixMax}€
                </Typography>
                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                  <TextField
                    type="number"
                    label="Prix min"
                    value={filters.prixMin}
                    onChange={(e) => setFilters({...filters, prixMin: Number(e.target.value)})}
                    sx={{ width: 120 }}
                  />
                  <Typography>-</Typography>
                  <TextField
                    type="number"
                    label="Prix max"
                    value={filters.prixMax}
                    onChange={(e) => setFilters({...filters, prixMax: Number(e.target.value)})}
                    sx={{ width: 120 }}
                  />
                </Box>
              </Box>
            </Grid>

            {/* Couleur */}
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Couleur</InputLabel>
                <Select
                  value={filters.couleur}
                  onChange={(e) => setFilters({...filters, couleur: e.target.value})}
                  label="Couleur"
                >
                  <MenuItem value="">Toutes les couleurs</MenuItem>
                  {couleurs.map(couleur => (
                    <MenuItem key={couleur} value={couleur}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box
                          sx={{
                            width: 16,
                            height: 16,
                            borderRadius: '50%',
                            backgroundColor: getColorValue(couleur),
                            border: '1px solid #ccc'
                          }}
                        />
                        {couleur}
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Style */}
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Style</InputLabel>
                <Select
                  value={filters.style}
                  onChange={(e) => setFilters({...filters, style: e.target.value})}
                  label="Style"
                >
                  <MenuItem value="">Tous les styles</MenuItem>
                  {styles.map(style => (
                    <MenuItem key={style} value={style}>{style}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
            <Button
              variant="contained"
              sx={{ backgroundColor: 'primary.main', '&:hover': { backgroundColor: 'primary.dark' } }}
            >
              Appliquer les filtres
            </Button>
            <Button
              variant="outlined"
              onClick={() => setFilters({
                taille: '',
                categorie: '',
                marque: '',
                prixMin: 0,
                prixMax: 500,
                distance: 10,
                couleur: '',
                style: ''
              })}
            >
              Réinitialiser
            </Button>
          </Box>
        </Paper>
      )}

      {/* Dates de location */}
      <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" gutterBottom sx={{ color: 'primary.main', display: 'flex', alignItems: 'center' }}>
          Dates de location
        </Typography>
        
        {/* Sélection de dates avec calendrier */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="body2" color="text.secondary" gutterBottom sx={{ mb: 2 }}>
            Sélectionnez votre période de location
          </Typography>
          
          {/* Résumé de sélection */}
          {(dateDebut || dateFin) && (
            <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8f9fa', borderRadius: 2, border: '1px solid', borderColor: 'primary.main' }}>
              <Typography variant="body1" sx={{ color: 'primary.main', fontWeight: 'bold', mb: 1 }}>
                {dateDebut && dateFin ? 
                  `${Math.ceil((dateFin.getTime() - dateDebut.getTime()) / (1000 * 60 * 60 * 24))} jour(s) sélectionné(s)` : 
                  'Sélectionnez vos dates'
                }
              </Typography>
              {dateDebut && dateFin && (
                <Typography variant="body2" color="text.secondary">
                  {dateDebut.toLocaleDateString('fr-FR', { 
                    day: 'numeric', 
                    month: 'short', 
                    year: 'numeric' 
                  })} - {dateFin.toLocaleDateString('fr-FR', { 
                    day: 'numeric', 
                    month: 'short', 
                    year: 'numeric' 
                  })}
                </Typography>
              )}
              {(dateDebut || dateFin) && (
                <Button
                  size="small"
                  onClick={() => {
                    setDateDebut(null);
                    setDateFin(null);
                    setTempStartDate(null);
                    setSelectingPeriod(false);
                  }}
                  sx={{ mt: 1, color: 'primary.main' }}
                >
                  Effacer les dates
                </Button>
              )}
            </Box>
          )}

          {/* Calendrier personnalisé, largeur limitée */}
          <Box sx={{ 
            mb: 2, 
            p: 1.5, 
            maxWidth: 320,
            mx: 'auto',
            backgroundColor: '#fafafa', 
            borderRadius: 2,
            border: '1px solid #e0e0e0',
            boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
          }}>
            <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold', color: 'primary.main', display: 'flex', alignItems: 'center', gap: 0.5, fontSize: '0.95rem' }}>
              📅 Calendrier de sélection
            </Typography>
            
            {selectingPeriod && (
              <Alert 
                severity="info" 
                sx={{ 
                  mb: 1,
                  py: 0.25,
                  backgroundColor: '#e3f2fd',
                  border: '1px solid #90caf9',
                  borderRadius: 1,
                  '& .MuiAlert-message': { py: 0.5 }
                }}
              >
                <Typography variant="caption" sx={{ display: 'block' }}>
                  <strong>Sélection en cours...</strong> Cliquez sur la date de fin
                </Typography>
              </Alert>
            )}
            
            {/* Navigation du calendrier */}
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center', 
              mb: 1,
              py: 0.75,
              px: 1,
              gap: 0.5,
              backgroundColor: 'white',
              borderRadius: 1,
              boxShadow: '0 1px 2px rgba(0,0,0,0.06)'
            }}>
              <Button 
                onClick={() => {
                  setCurrentMonth(prev => {
                    const newMonth = new Date(prev);
                    newMonth.setMonth(prev.getMonth() - 1);
                    return newMonth;
                  });
                }}
                variant="outlined"
                size="small"
                sx={{ 
                  minWidth: 0,
                  px: 1,
                  py: 0.25,
                  fontSize: '0.7rem',
                  borderColor: 'primary.main', 
                  color: 'primary.main',
                  '&:hover': {
                    borderColor: 'primary.dark',
                    backgroundColor: '#f5f5f5'
                  }
                }}
              >
                ← Préc.
              </Button>
              <Typography variant="body2" sx={{ color: 'primary.main', fontWeight: 'bold', textTransform: 'capitalize', fontSize: '0.8rem', textAlign: 'center', flex: 1, lineHeight: 1.2 }}>
                {currentMonth.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' })}
              </Typography>
              <Button 
                onClick={() => {
                  setCurrentMonth(prev => {
                    const newMonth = new Date(prev);
                    newMonth.setMonth(prev.getMonth() + 1);
                    return newMonth;
                  });
                }}
                variant="outlined"
                size="small"
                sx={{ 
                  minWidth: 0,
                  px: 1,
                  py: 0.25,
                  fontSize: '0.7rem',
                  borderColor: 'primary.main', 
                  color: 'primary.main',
                  '&:hover': {
                    borderColor: 'primary.dark',
                    backgroundColor: '#f5f5f5'
                  }
                }}
              >
                Suiv. →
              </Button>
            </Box>

            {/* Grille du calendrier */}
            <Box sx={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(7, minmax(0, 1fr))', 
              gap: 0.5,
              mb: 1,
              p: 1,
              backgroundColor: 'white',
              borderRadius: 1,
              boxShadow: '0 1px 2px rgba(0,0,0,0.06)'
            }}>
              {/* En-têtes des jours */}
              {['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'].map(day => (
                <Typography 
                  key={day} 
                  variant="caption" 
                  sx={{ 
                    textAlign: 'center', 
                    fontWeight: 'bold', 
                    py: 0.35,
                    px: 0,
                    fontSize: '0.65rem',
                    color: 'primary.main',
                    backgroundColor: '#f8f9fa',
                    borderRadius: 0.5
                  }}
                >
                  {day}
                </Typography>
              ))}
              
              {/* Dates du calendrier */}
              {(() => {
                const year = currentMonth.getFullYear();
                const month = currentMonth.getMonth();
                const firstDay = new Date(year, month, 1);
                const lastDay = new Date(year, month + 1, 0);
                const startDate = new Date(firstDay);
                startDate.setDate(startDate.getDate() - firstDay.getDay());
                
                const dates = [];
                for (let i = 0; i < 42; i++) {
                  const date = new Date(startDate);
                  date.setDate(startDate.getDate() + i);
                  dates.push(date);
                }
                
                return dates.map((date, index) => {
                  const isCurrentMonth = date.getMonth() === month;
                  const isToday = date.toDateString() === new Date().toDateString();
                  const today = new Date();
                  today.setHours(0, 0, 0, 0);
                  const isPast = date < today;
                  
                  const isSelected = dateDebut && dateFin && date >= dateDebut && date <= dateFin;
                  const isStart = dateDebut && date.getTime() === dateDebut.getTime();
                  const isEnd = dateFin && date.getTime() === dateFin.getTime();
                  const isTempStart = tempStartDate && date.getTime() === tempStartDate.getTime();
                  
                  return (
                    <Button
                      key={index}
                      onClick={() => {
                        if (isPast) return;
                        
                        if (!selectingPeriod) {
                          // Premier clic : commencer la sélection
                          setTempStartDate(date);
                          setSelectingPeriod(true);
                        } else {
                          // Deuxième clic : terminer la sélection
                          let startDate: Date;
                          let endDate: Date;
                          
                          if (tempStartDate && date > tempStartDate) {
                            startDate = tempStartDate;
                            endDate = date;
                          } else if (tempStartDate && date < tempStartDate) {
                            startDate = date;
                            endDate = tempStartDate;
                          } else {
                            // Même date : sélection d'un jour
                            startDate = date;
                            endDate = date;
                          }
                          
                          setDateDebut(startDate);
                          setDateFin(endDate);
                          setSelectingPeriod(false);
                          setTempStartDate(null);
                        }
                      }}
                      disabled={isPast}
                      sx={{
                        minWidth: 0,
                        width: '100%',
                        maxWidth: '100%',
                        height: 34,
                        minHeight: 34,
                        p: 0,
                        borderRadius: 1,
                        backgroundColor: isSelected ? 'primary.main' : 
                                       isTempStart ? accentSoft :
                                       isCurrentMonth ? (isToday ? '#e3f2fd' : '#f8f9fa') : '#fafafa',
                        color: isSelected ? 'white' : 
                               isCurrentMonth ? '#333' : '#ccc',
                        border: isStart || isEnd ? `2px solid ${theme.palette.primary.main}` : 
                                isToday ? '2px solid #1976d2' : '1px solid transparent',
                        fontWeight: isSelected || isStart || isEnd ? 'bold' : 'normal',
                        fontSize: '0.75rem',
                        lineHeight: 1,
                        transition: 'background-color 0.15s ease',
                        '&:hover': {
                          backgroundColor: isPast ? 'transparent' : (isSelected ? 'primary.dark' : accentSoft),
                          transform: 'none',
                          boxShadow: isPast ? 'none' : `0 1px 4px ${accentGlow}`,
                        },
                        '&:disabled': {
                          backgroundColor: '#f5f5f5',
                          color: '#ccc',
                          cursor: 'not-allowed'
                        }
                      }}
                    >
                      {date.getDate()}
                    </Button>
                  );
                });
              })()}
            </Box>

            {/* Légende */}
            <Box sx={{ 
              display: 'flex', 
              gap: 1, 
              rowGap: 0.5,
              flexWrap: 'wrap', 
              justifyContent: 'center', 
              mt: 1,
              pt: 1,
              borderTop: '1px solid #e0e0e0'
            }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Box sx={{ 
                  width: 12, 
                  height: 12, 
                  flexShrink: 0,
                  backgroundColor: 'primary.main', 
                  borderRadius: 0.5,
                  boxShadow: '0 1px 2px rgba(0,0,0,0.15)'
                }} />
                <Typography variant="caption" sx={{ fontWeight: 'medium', fontSize: '0.65rem' }}>Sélectionné</Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Box sx={{ 
                  width: 12, 
                  height: 12, 
                  flexShrink: 0,
                  backgroundColor: '#f8f9fa', 
                  borderRadius: 0.5,
                  border: '1px solid #e0e0e0'
                }} />
                <Typography variant="caption" sx={{ fontWeight: 'medium', fontSize: '0.65rem' }}>Disponible</Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Box sx={{ 
                  width: 12, 
                  height: 12, 
                  flexShrink: 0,
                  backgroundColor: '#f5f5f5', 
                  borderRadius: 0.5,
                  border: '1px solid #e0e0e0'
                }} />
                <Typography variant="caption" sx={{ fontWeight: 'medium', fontSize: '0.65rem' }}>Passé</Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Box sx={{ 
                  width: 12, 
                  height: 12, 
                  flexShrink: 0,
                  backgroundColor: '#e3f2fd', 
                  borderRadius: 0.5,
                  border: '2px solid #1976d2'
                }} />
                <Typography variant="caption" sx={{ fontWeight: 'medium', fontSize: '0.65rem' }}>Aujourd'hui</Typography>
              </Box>
            </Box>
          </Box>
          
          
          {/* Affichage de la durée */}
          {dateDebut && dateFin && (
            <Box sx={{ mt: 2, p: 2, backgroundColor: '#e8f5e8', borderRadius: 2 }}>
              <Typography variant="body2" sx={{ color: '#2e7d32', fontWeight: 'bold' }}>
                📊 Durée de location: {Math.ceil((dateFin.getTime() - dateDebut.getTime()) / (1000 * 60 * 60 * 24))} jour(s)
              </Typography>
            </Box>
          )}
      </Box>


        {/* Bouton de recherche avec les dates */}
        {(dateDebut || dateFin) && (
          <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
            <Button
              variant="contained"
              sx={{ 
                backgroundColor: 'primary.main', 
                '&:hover': { backgroundColor: 'primary.dark' },
                flex: 1
              }}
            >
              🔍 Rechercher les robes disponibles
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                setDateDebut(null);
                setDateFin(null);
              }}
            >
              Effacer les dates
            </Button>
          </Box>
        )}
      </Paper>

      {/* Carte */}
      <Paper elevation={2} sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom sx={{ color: 'primary.main' }}>
          Localisation
        </Typography>
        <MapSection />
      </Paper>

      {/* Section de tri */}
      <Paper elevation={2} sx={{ p: 3, mt: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6" sx={{ color: 'primary.main' }}>
            Robes disponibles
          </Typography>
          
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <FormControlLabel
              control={
                <Switch
                  checked={showStats}
                  onChange={(e) => setShowStats(e.target.checked)}
                  sx={{ 
                    '& .MuiSwitch-switchBase.Mui-checked': {
                      color: 'primary.main',
                    },
                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                      backgroundColor: 'primary.main',
                    }
                  }}
                />
              }
              label="Afficher les statistiques"
            />
          </Box>
        </Box>

        {/* Options de tri */}
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 3 }}>
          {[
            { key: 'proximite', label: '📍 Proximité' },
            { key: 'prix', label: '💰 Prix' },
            { key: 'popularite', label: '⭐ Popularité' },
            { key: 'nouveautes', label: '🆕 Nouveautés' }
          ].map((option) => (
            <Chip
              key={option.key}
              label={`${option.label} ${sortBy === option.key ? (sortOrder === 'asc' ? '↑' : '↓') : ''}`}
              onClick={() => handleSortChange(option.key as typeof sortBy)}
              variant={sortBy === option.key ? 'filled' : 'outlined'}
              sx={{
                backgroundColor: sortBy === option.key ? 'primary.main' : 'transparent',
                color: sortBy === option.key ? 'white' : 'primary.main',
                borderColor: 'primary.main',
                '&:hover': {
                  backgroundColor: sortBy === option.key ? 'primary.dark' : alpha(theme.palette.primary.main, 0.08),
                }
              }}
            />
          ))}
        </Box>
        
        <Grid container spacing={3}>
          {/* Charger les robes depuis Firestore */}
          {loadingDresses ? (
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                <CircularProgress />
              </Box>
            </Grid>
          ) : dresses.length === 0 ? (
            <Grid item xs={12}>
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <Typography variant="body1" color="text.secondary">
                  Aucune robe disponible pour le moment
                </Typography>
              </Box>
            </Grid>
          ) : (
            sortDresses(dresses).map((dress) => (
            <Grid item xs={12} sm={6} md={3} key={dress.id}>
              <Card
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  cursor: 'pointer',
                  borderRadius: 2,
                  bgcolor: '#fff',
                  border: `1px solid ${alpha(theme.palette.divider, 1)}`,
                  boxShadow: 'none',
                  overflow: 'hidden',
                  transition: 'transform 0.45s cubic-bezier(0.22, 1, 0.36, 1), box-shadow 0.45s ease',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: `0 24px 56px ${alpha(theme.palette.common.black, 0.08)}`,
                  },
                  '&:hover .MuiCardMedia-root': {
                    transform: 'scale(1.03)',
                  },
                }}
                onClick={() => {
                  navigate(`/dashboard/dress/${dress.id}`);
                }}
              >
                <Box sx={{ bgcolor: alpha(theme.palette.secondary.light, 0.25) }}>
                  <CardMedia
                    component="img"
                    image={dress.image}
                    alt={dress.title}
                    sx={{
                      width: '100%',
                      aspectRatio: '3 / 4',
                      height: 'auto',
                      objectFit: 'cover',
                      transition: 'transform 0.65s ease',
                      transformOrigin: 'center center',
                    }}
                  />
                </Box>
                <CardContent sx={{ pt: 2.5, pb: 2.5, px: 2, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                  <Typography variant="overline" sx={{ fontSize: '0.6rem', letterSpacing: '0.18em', color: 'text.secondary', mb: 0.5 }}>
                    Robe
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{
                      fontFamily: '"Cormorant Garamond", serif',
                      fontWeight: 600,
                      fontSize: '1.05rem',
                      lineHeight: 1.25,
                      mb: 1,
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                    }}
                  >
                    {dress.title}
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 1, flexWrap: 'wrap' }}>
                    <Typography variant="caption" color="text.secondary">
                      {dress.owner}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
                      <StarIcon sx={{ fontSize: 14, color: alpha(theme.palette.secondary.dark, 0.9) }} />
                      <Typography variant="caption" color="text.secondary">
                        {dress.rating}
                      </Typography>
                    </Box>
                  </Box>
                  <Typography variant="body2" sx={{ color: 'primary.main', fontWeight: 600, mb: 0.75 }}>
                    {dress.price} € <Box component="span" sx={{ fontWeight: 400, color: 'text.secondary', fontSize: '0.8rem' }}>/ jour</Box>
                  </Typography>
                  <Typography variant="caption" color="text.secondary" sx={{ mb: 1 }}>
                    Taille {dress.size}
                  </Typography>
                  <Typography variant="caption" color="text.secondary" sx={{ letterSpacing: '0.03em', mb: showStats ? 2 : 0 }}>
                    {dress.location}
                    {dress.distance ? ` · ${dress.distance} km` : ''}
                  </Typography>
                  {showStats && (
                    <Box sx={{ mt: 'auto', pt: 2, borderTop: '1px solid', borderColor: 'divider' }}>
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.75, letterSpacing: '0.08em' }}>
                        Vues {dress.views} · Favoris {dress.favorites}
                      </Typography>
                      <Typography variant="caption" color="text.disabled">
                        Ajoutée le {new Date(dress.dateAdded).toLocaleDateString('fr-FR')}
                      </Typography>
                    </Box>
                  )}
                </CardContent>
              </Card>
            </Grid>
            ))
          )}
        </Grid>
      </Paper>
    </Box>
  );
};

export default RechercheTab;